var iFitSubscribe = (function() { //eslint-disable-line no-unused-vars
  var host = location.host;
  var isProd = /ifitnourish(?:\.myshopify)?\.com/.test(host);
  var longHost = isProd ? 'ifitnourish.myshopify.com' : host;
  var shop = longHost.split('.')[0];
  var backend = isProd ? 'https://api.ifit.com' : 'https://api-local.ifit-dev.com:8443';

  var skuData = [
    {
      sku: 'IFNPCMC',
      calories: 190,
      protein: 20,
      oz: 30,
      g: 855,
      formula: 43734
    },
    {
      sku: 'IFNPCMV',
      calories: 190,
      protein: 20,
      oz: 30,
      g: 840,
      formula: 13301
    },
    {
      sku: 'IFNPCFC',
      calories: 150,
      protein: 15,
      oz: 24,
      g: 675,
      formula: 30177
    },
    {
      sku: 'IFNPCFV',
      calories: 150,
      protein: 15,
      oz: 23,
      g: 660,
      formula: 23287
    },
    {
      sku: 'IFNPWMC',
      calories: 110,
      protein: 18,
      oz: 19,
      g: 525,
      formula: 58690
    },
    {
      sku: 'IFNPWMV',
      calories: 110,
      protein: 18,
      oz: 18,
      g: 518,
      formula: 80877
    },
    {
      sku: 'IFNPWFC',
      calories: 90,
      protein: 16,
      oz: 15,
      g: 435,
      formula: 71534
    },
    {
      sku: 'IFNPWFV',
      calories: 90,
      protein: 16,
      oz: 15,
      g: 420,
      formula: 33617
    },
    {
      sku: 'IFNPLMC',
      calories: 160,
      protein: 30,
      oz: 23,
      g: 645,
      formula: 34317
    },
    {
      sku: 'IFNPLMV',
      calories: 160,
      protein: 30,
      oz: 23,
      g: 645,
      formula: 24671
    },
    {
      sku: 'IFNPLFC',
      calories: 130,
      protein: 25,
      oz: 19,
      g: 540,
      formula: 12320
    },
    {
      sku: 'IFNPLFV',
      calories: 130,
      protein: 25,
      oz: 19,
      g: 533,
      formula: 19177
    },
    {
      sku: 'IFNPPMC',
      calories: 160,
      protein: 20,
      oz: 25,
      g: 713,
      formula: 49486
    },
    {
      sku: 'IFNPPMV',
      calories: 150,
      protein: 20,
      oz: 24,
      g: 690,
      formula: 59513
    },
    {
      sku: 'IFNPPFC',
      calories: 150,
      protein: 20,
      oz: 23,
      g: 645,
      formula: 74464
    },
    {
      sku: 'IFNPPFV',
      calories: 140,
      protein: 20,
      oz: 22,
      g: 623,
      formula: 74170
    },
    {
      sku: 'IFNMCMC',
      calories: 260,
      protein: 24,
      oz: 41,
      g: 1155,
      formula: 11565
    },
    {
      sku: 'IFNMCMV',
      calories: 260,
      protein: 24,
      oz: 40,
      g: 1140,
      formula: 92696
    },
    {
      sku: 'IFNMCFC',
      calories: 230,
      protein: 21,
      oz: 36,
      g: 1013,
      formula: 23233
    },
    {
      sku: 'IFNMCFV',
      calories: 230,
      protein: 21,
      oz: 35,
      g: 1005,
      formula: 33747
    },
    {
      sku: 'IFNMWMC',
      calories: 160,
      protein: 22,
      oz: 26,
      g: 750,
      formula: 24760
    },
    {
      sku: 'IFNMWMV',
      calories: 160,
      protein: 22,
      oz: 26,
      g: 735,
      formula: 43293
    },
    {
      sku: 'IFNMWFC',
      calories: 130,
      protein: 20,
      oz: 21,
      g: 608,
      formula: 34263
    },
    {
      sku: 'IFNMWFV',
      calories: 130,
      protein: 20,
      oz: 22,
      g: 615,
      formula: 14625
    },
    {
      sku: 'IFNMLMC',
      calories: 230,
      protein: 40,
      oz: 35,
      g: 1005,
      formula: 41359
    },
    {
      sku: 'IFNMLMV',
      calories: 220,
      protein: 40,
      oz: 35,
      g: 990,
      formula: 97522
    },
    {
      sku: 'IFNMLFC',
      calories: 180,
      protein: 30,
      oz: 29,
      g: 825,
      formula: 36370
    },
    {
      sku: 'IFNMLFV',
      calories: 180,
      protein: 30,
      oz: 29,
      g: 810,
      formula: 20584
    },
    {
      sku: 'IFNMPMC',
      calories: 190,
      protein: 25,
      oz: 30,
      g: 840,
      formula: 55961
    },
    {
      sku: 'IFNMPMV',
      calories: 190,
      protein: 25,
      oz: 29,
      g: 825,
      formula: 93634
    },
    {
      sku: 'IFNMPFC',
      calories: 160,
      protein: 20,
      oz: 26,
      g: 735,
      formula: 29662
    },
    {
      sku: 'IFNMPFV',
      calories: 160,
      protein: 20,
      oz: 25,
      g: 705,
      formula: 63769
    }
  ];

  function skuInfo(sku) {
    sku = String(sku).substr(0, 7).toUpperCase();
    for (var i = 0; i < skuData.length; i++) {
      if (skuData[i].sku === sku) return skuData[i];
    }
  }

  function checkBold(cb) {
    if (!window.BOLD) {
      var err = new Error('Bold app not found');
      if (!cb) {
        throw err;
      } else {
        cb(err);
        return false;
      }
    }
    return window.BOLD;
  }

  function async(task, funcs, cb) {
    if (typeof task !== 'string') {
      cb = funcs;
      funcs = task;
      task = '';
    }

    if (task) {
      return withTask(task, function() {
        async('', funcs, cb);
      });
    }
    cb = cb || function(err) {
      if (err) console.log(err.stack); //eslint-disable-line no-console
    };
    var toDo = funcs.slice(1);
    var current = funcs[0];
    if (!current) return cb();
    if (!current.length) {
      try {
        current();
      } catch (err) {
        return cb(err);
      }
      async(toDo, cb);
    } else {
      current(function(err) {
        if (err) return cb(err);
        async(toDo, cb);
      });
    }
  }

  function mapSerial(array, func, cb) {
    array = array.slice();
    var result = [];
    next();

    function next() {
      if (!array.length) return cb(null, result);
      var v = array.shift();
      func(v, function(err, res) {
        if (err) return cb(err);
        result.push(res);
        next();
      });
    }
  }

  function apiUrl(path) {
    return 'https://' + host + '/tools/checkout/front_end/' + (path || '');
  }

  function isLoggedIn() {
    var BOLD = checkBold();
    return Boolean(BOLD.customer && BOLD.customer.id);
  }

  var tasks = [];
  function withTask(task, cb) {
    tasks.push(task);
    cb();
    tasks.pop();
  }

  function ajaxError(cb, task, ignoreStatuses) {
    ignoreStatuses = (ignoreStatuses || []).map(Number);
    if (tasks.length) {
      task = tasks[0];
    }
    var stack = (new Error()).stack;
    return function(xhr, textStatus, errorThrown) {
      //"timeout", "error", "abort", and "parsererror"
      var message;
      if (textStatus === 'timeout') {
        message = 'Timed waiting for server response';
      } else if (textStatus === 'abort' || xhr.status === 0) {
        message = 'The request was aborted';
      } else if (textStatus === 'parsererror') {
        message = 'The response from the server could not be parsed';
      } else {
        if (ignoreStatuses.indexOf(xhr.status) !== -1) {
          return cb();
        }
        message = xhr.responseText;
        if (!message || message.length > 500 || /$\s*</.test(message)) {
          var errors = {
            400: 'bad request',
            401: 'authorization',
            403: 'access denied',
            404: 'resource not found',
            500: 'internal server',
            502: 'bad gateway',
            503: 'service unavailable',
            504: 'gateway timeout',
          };
          var status = xhr.status;
          if (!errors[status]) {
            status = Math.floor(status / 100) * 100;
          }
          if (errors[status]) {
            message = normalizeMessage(errors[status]);
          } else if (errorThrown) {
            message = normalizeMessage(errorThrown);
          } else {
            message = normalizeMessage('http error ' + xhr.status);
          }
        }
      }
      var err = new Error(message + (task ? ' while ' + task : ''));
      if (stack) {
        try {
          err.stack = stack;
          err.tasks = tasks.slice().concat(task ? task : []).join(', ');
        } catch (err) {
          //ignore
        }
      }
      cb(err);
    };

    function normalizeMessage(text) {
      return ((/^(?:[aeoui]|$|http)/i.test(text) ? 'An ' : 'A ') + text.toLowerCase() + ' error occurred').replace(/\s+/g, ' ');
    }
  }

  var boldCredentials;
  var boldCredentialsPending;
  function getBoldCredentials(cb) {
    if (boldCredentials) return cb(null, boldCredentials);
    if (boldCredentialsPending) {
      boldCredentialsPending.push(cb);
      return;
    }
    var BOLD = checkBold(cb);
    if (!BOLD) return;
    var customer = BOLD.customer;
    if (!customer) return cb(new Error('Customer not logged in'));

    boldCredentialsPending = [];
    $.ajax({
      url: 'https://' + host + '/tools/checkout/front_end/check_login/' + customer.id,
      type: 'get',
      success: function(response) {
        var result = {};
        var err = null;
        var props = ['bold_token', 'bold_signature'];

        props.forEach(function(name) {
          result[name] = fetchProp(name);
        });

        boldCredentials = result;
        cb(err, result);
        boldCredentialsPending.forEach(function(cb) {
          cb(err, result);
        });
        function fetchProp(name) {
          var match = (new RegExp('[&\?]' + name + '=([^&"]*)[&"]')).exec(response);
          if (!match) {
            err = new Error(name + ' not found in Bold form');
            return;
          }
          return match[1];
        }
      },
      error: ajaxError(cb, 'getting credentials')
    });
  }

  function getSubscriptions(cb) {
    var credentials;
    var subscriptions;
    async('retrieving subscriptions', [
      function(next) {
        getBoldCredentials(function(err, _credentials) {
          credentials = _credentials;
          next(err);
        });
      },
      function(next) {
        $.ajax({
          url: apiUrl('recurring_orders'),
          type: 'get',
          data: credentials,
          success: function(response) {
            var regExp = /class="(skip|recover)_order" data-id="([^"]*)" data-date="([^"]*)">/g;

            var subs = {};
            var match;
            while (match = regExp.exec(response)) { //eslint-disable-line no-cond-assign
              var list = subs[match[2]];
              if (!list) {
                list = [];
                subs[match[2]] = list;
              }
              list.push({
                skipped: match[1] === 'recover',
                date: match[3]
              });
            }
            subscriptions = subs;
            next();
          },
          error: ajaxError(next)
        });
      }
    ], function(err) {
      if (err) return cb(err);
      cb(null, subscriptions);
    });
  }

  function skipShipSubscriptionOrder(subscriptionId, date, kind, cb) {
    kind = String(kind).toLowerCase();
    var ship = ['recover', 'ship', 'resume'].indexOf(kind) !== -1;
    var skip = !ship && ['cancel', 'skip'].indexOf(kind) !== -1;
    if (!ship && !skip) return cb(new Error('kind must be "skip" or "ship"'));
    var action = skip ? 'skip' : 'recover';
    withTask((skip ? 'skipping' : 'resuming') + ' a shipment', function() {
      getBoldCredentials(function(err, credentials) {
        if (err) return cb(err);
        /* eslint-disable camelcase */
        $.ajax({
          url: apiUrl(action + '_order'),
          type: 'post',
          dataType: 'text',
          data: {
            id: subscriptionId,
            order_date: date,
            bold_token: credentials.bold_token,
            bold_signature: credentials.bold_signature
          },
          success: function() {
            cb();
          },
          error: ajaxError(cb, action + ' a shipment', [302])
        });
        /* eslint-enable camelcase */
      });
    });
  }

  function dateAsIso(date) {
    return date.getFullYear() + '-' + pad(date.getMonth() + 1) + '-' + pad(date.getDate());

    function pad(value) {
      value = String(value);
      if (value.length < 2) value = '0' + value;
      return value;
    }
  }

  function setNextOrderDate(subscriptionId, newDate, cb) {
    if (newDate instanceof Date) {
      newDate = dateAsIso(newDate);
    }
    getBoldCredentials(function(err, credentials) {
      if (err) return cb(err);
      /* eslint-disable camelcase */
      $.ajax({
        url: apiUrl('save_new_ship_date/' + subscriptionId),
        type: 'post',
        dataType: 'text',
        data: {
          next_shipping_date: newDate,
          bold_token: credentials.bold_token,
          bold_signature: credentials.bold_signature
        },
        success: function() {
          cb();
        },
        error: ajaxError(cb, 'setting the subscription\'s next order date', [302])
      });
      /* eslint-enable camelcase */
    });
  }

  function getSubscriptionInfo(subscription, cb) {
    var credentials;
    var products = [];
    async('retrieving subscriptions', [
      function(next) {
        getBoldCredentials(function(err, _credentials) {
          credentials = _credentials;
          next(err);
        });
      },
      function(next) {
        $.ajax({
          url: apiUrl('view_products/' + subscription),
          type: 'get',
          data: credentials,
          success: function(response) {
            var regExp = /<td><img src="([^"]*)".*?<\/td><td>(.*?)<\/td><td>(.*?)<\/td><td>(.*?)<\/td><td>(.*?)<\/td><td><input type="text" name=quantity\[] value="(.*?)"><\/td><td>.*?data-product-internal-id="([^"]*)"><\/td>/g;
            var match;
            while (match = regExp.exec(response)) { //eslint-disable-line no-cond-assign
              products.push({
                img: match[1],
                name: match[2],
                variant: match[3],
                sku: match[4],
                price: match[5],
                quantity: match[6],
                internalProductId: match[7]
              });
            }
            next(null);
          },
          error: ajaxError(next)
        });
      },
    ], function(err) {
      if (err) return cb(err);
      cb(null, products);
    });
  }

  function getAllSubscriptionInfo(cb) {
    getSubscriptions(function(err, subscriptions) {
      if (err) return cb(err);
      var ids = Object.keys(subscriptions);
      mapSerial(ids, getSubscriptionInfo, function(err, subscriptionProducts) {
        if (err) return cb(err);
        var fullSubscriptions = {};
        ids.forEach(function(id, ix) {
          fullSubscriptions[id] = {
            orders: subscriptions[id],
            products: subscriptionProducts[ix],
            id: id
          };
        });
        cb(null, fullSubscriptions);
      });
    });
  }

  var productsBySku = {};
  function productFromSku(sku, cb) {
    sku = String(sku).toLowerCase();

    if (productsBySku[sku]) return cb(null, productsBySku[sku]);

    $.ajax({
      url: 'https://' + host + '/products/ifit-nourish-' + sku.substr(3) + '?view=nourish-json',
      dataType: 'text', //If this is json, the template will not be used
      success: function(response) {
        var prod = JSON.parse(response);
        var ro = prod.ro;
        var product = prod.product;
        product.supplement_facts = prod.supplement_facts; // eslint-disable-line camelcase

        if (ro) {
          product.variants.forEach(function(variant, ix) {
            variant.ro_lookup = ro[ix]; // eslint-disable-line camelcase
          });
        }
        productsBySku[sku] = product;
        return cb(null, product);
      },
      error: ajaxError(cb, 'getting product info')
    });
  }

  function variantFromSku(sku, cb) {
    sku = String(sku).toLowerCase();
    productFromSku(sku, function(err, product) {
      if (err) return cb(err);
      var variant = product.variants[0];
      variant.product = product;
      if (!variant || String(variant.sku).toLowerCase() !== sku) return cb(new Error('Incorrect product variant'));
      cb(null, variant);
    });
  }

  function swapProduct(subscription, originalSku, replacementSku, cb) {
    replacementSku = replacementSku.replace(/[IRT]?$/i, 'R');
    var BOLD = checkBold(cb);
    if (!BOLD) return;

    var replacement;
    var found;
    var credentials;

    async('swapping your products', [
      function(next) {
        if (!subscription) {
          getSubscriptions(function(err, subscriptions) {
            if (err) return cb(err);
            var subscriptionIds = Object.keys(subscriptions);
            if (!subscriptionIds.length) {
              return next(new Error('No subscription found'));
            }
            if (subscriptionIds.length > 1) {
              return next(new Error('Multiple subscriptions found'));
            }
            subscription = subscriptionIds[0];
            next();
          });
        } else {
          next();
        }
      },
      function(next) {
        variantFromSku(replacementSku, function(err, variant) {
          replacement = variant;
          next(err);
        });
      },
      function(next) {
        getSubscriptionInfo(subscription, function(err, products) {
          if (err) return next(err);
          if (!products.length) return next(new Error('No product to replace'));

          if (originalSku) {
            originalSku = originalSku.toUpperCase();
            found = products.filter(function(product) {
              return product.sku.toUpperCase() === originalSku;
            })[0];
            if (!found) return cb(new Error('Product with SKU ' + originalSku + ' not found'));
          } else {
            if (products.length !== 1) return cb(new Error('Indeterminate product swap'));
            found = products[0];
          }
          next();
        });
      },
      function(next) {
        getBoldCredentials(function(err, _credentials) {
          credentials = _credentials;
          next(err);
        });
      },
      function(next) {
        var data = credentials;

        /* eslint-disable camelcase */
        data.product_id = replacement.product.id;
        data.variant_id = replacement.id;
        data.group_id = replacement.ro_lookup.group_id;
        data.product_internal_id = found.internalProductId;
        data.csrf_bold_token = BOLD.recurring_orders.csrf_token;
        /* eslint-enable camelcase */

        $.ajax({
          url: apiUrl('save_swap_product'),
          data: data,
          type: 'post',
          success: function() {
            next();
          },
          error: ajaxError(next, null, [302])
        });
      }
    ], function(err) {
      if (err) return cb(err);
      cb(null, replacement);
    });
  }

  function getSubscribeSetupData(variant, cb) {
    var BOLD = checkBold(cb);
    if (!BOLD) return;

    var result;
    async('subscribing', [
      function(next) {
        if (typeof variant === 'string') {
          variantFromSku(variant, function(err, _variant) {
            variant = _variant;
            next(err);
          });
        } else {
          next();
        }
      },
      function(next) {
        var data = {
          /* eslint-disable camelcase */
          shop_url: longHost,
          group_id: variant.ro_lookup.group_id,
          customer_id: (BOLD.customer && BOLD.customer.id) || '',
          product_id: variant.product.id,
          variant_id: variant.id,
          v: 2,
          _: Date.now()
          /* eslint-enable camelcase */
        };

        var url = makeGetUrl('https://ro.boldapps.net/recurring_settings/generate_rp', data);
        var catcher = dataCatcher();

        var timeout = setTimeout(function() {
          next(new Error('Error loading subscribe info'));
          next = function() {};
        }, 10000);

        BOLD.helpers.loadScript(url, function() {
          clearTimeout(timeout);
          var keys = ['discounted_price', 'ro_discount_percentage', 'ro_unformatted_price'];
          result = {};
          var err = null;
          keys.forEach(function(key) {
            var field = catcher.find('.' + key);
            if (!field.length && !err) {
              err = new Error('Field ' + field + 'not found');
            }
            result[key] = field.val();
          });
          result.csrf_bold_token = BOLD.recurring_orders.csrf_token; //eslint-disable-line camelcase
          next();
        });

        function dataCatcher() {
          var form = $('#customButton').closest('form');
          if (!form.length) {
            form = $('<form><div id="customButton" style="display:none"></form></div>');
            $('body').append(form);
          }
          return form;
        }
      }
    ], function(err) {
      cb(err, result);
    });
  }

  function getGroupInfo(groupId, cb) {
    $.ajax({
      url: 'https://ro.boldapps.net/api_public/group/' + groupId + '?shop_url=' + longHost,
      type: 'get',
      dataType: 'json',
      success: function(response) {
        cb(null, response);
      },
      error: ajaxError(cb, 'getting subscription type info')
    });
  }

  function fetchSupplementFacts(sku, cb) {
    productFromSku(sku.replace(/[ir]?$/i, 'i'), function(err, res) {
      if (err) return cb(err);

      cb(null, res.supplement_facts);
    });
  }

  function addSubscriptionToCart(sku, kind, cb) {
    if (typeof kind === 'function') {
      cb = kind;
      kind = 'recurring';
    }
    var BOLD = checkBold(cb);
    if (!BOLD) return;

    var variant;
    var setupData;
    var groupInfo;
    var data;
    var response;
    var trailer = {
      recurring: 'r',
      initial: 'i',
      trial: 't'
    }[kind.toLowerCase()];
    var convertible = trailer !== 'r';
    if (!trailer) {
      return cb(new Error('Incorrect parameter for subscription kind'));
    }
    async('adding a subscription to your cart', [
      function(next) {
        variantFromSku(sku.replace(/[irt]?$/i, trailer), function(err, _variant) {
          variant = _variant;
          next(err);
        });
      },
      function(next) {
        if (convertible) {
          getGroupInfo(variant.ro_lookup.group_id, function(err, info) {
            groupInfo = info;
            next(err);
          });
        } else {
          getSubscribeSetupData(variant, function(err, _setupData) {
            setupData = _setupData;
            next(err);
          });
        }
      },
      function() {
        if (convertible) {
          var discountedPrice = variant.price * groupInfo.discount_percentage;
          data = {
            'id': variant.id,
            'bold-ro__selector_radio_button': 2,
            'properties[frequency_num]': 1,
            'properties[frequency_type]': 3,
            'properties[frequency_type_text]': 'Month(s)',
            'properties[group_id]': variant.ro_lookup.group_id,
            'properties[discounted_price]': '$' + discountedPrice.toFixed(2),
            'properties[_ro_discount_percentage]': groupInfo.group_discount,
            'properties[_ro_unformatted_price]': discountedPrice,
            'csrf_bold_token': groupInfo.csrf_token,
            'quantity': 1
          };
        } else {
          data = {
            'id': variant.id,
            'recurring_radio_btn': 2,
            'frequency_num': 1,
            'properties[frequency_num]': 1,
            'frequency_type': 3,
            'properties[frequency_type]': 3,
            'properties[frequency_type_text]': 'Month(s)',
            'group_id': variant.ro_lookup.group_id,
            'properties[group_id]': variant.ro_lookup.group_id,
            'properties[discounted_price]': setupData.discounted_price,
            'properties[_ro_discount_percentage]': setupData.ro_discount_percentage,
            'properties[_ro_unformatted_price]': setupData.ro_unformatted_price,
            'csrf_bold_token': setupData.csrf_bold_token,
            'quantity': 1,
            'quantities[]': 1,
            'product_id[]': variant.product.id,
            'variant_id[]': variant.id,
            'note': ''
          };
        }
      },
      function(next) {
        $.ajax({
          url: 'https://' + host + '/cart/add.js',
          type: 'post',
          data: data,
          dataType: 'json',
          success: function(_response) {
            response = _response;
            next();
          },
          error: ajaxError(cb)
        });
      }
    ], function(err) {
      cb(err, response);
    });
  }

  function clearCart(cb) {
    $.ajax({
      type: 'POST',
      url: '/cart/clear.js',
      dataType: 'json',
      success: function(response) {
        cb(null, response);
      },
      error: ajaxError(cb, 'clearing your cart')
    });
  }

  function loginAndRedirect(url, maxMinutes) {
    var key = 'login_redirect';
    if (window.localStorage) {
      window.localStorage[key] = JSON.stringify({
        validUntil: Date.now() + (maxMinutes || 30) * 60e3,
        url: url
      });
    }
    window.location = '/account/login';
  }

  function decodeQuery(url, translate) {
    if (!url) {
      url = window.location.href;
    }
    var search = url.split('?')[1];
    var pairs = search && search.split('&');
    var params = {};
    if (pairs && pairs[0]) {
      pairs.forEach(function(pair) {
        var isNull = false;
        var ix = pair.indexOf('=');
        if (ix === -1) {
          ix = pair.length;
          isNull = true;
        }
        var key = pair.substr(0, ix);
        if (translate || typeof translate === 'undefined') {
          key = key.replace(/[-_](.)/g, function(_, letter) {
            return letter.toUpperCase();
          });
        }
        params[key] = isNull ? null : decodeURIComponent(pair.substr(ix + 1));
      });
    }
    return params;
  }

  function makeGetUrl(url, data) {
    var urlQuery = decodeQuery(url, false);
    url = url.split('?')[0];
    data = $.extend({}, urlQuery, data);
    var keys = Object.keys(data);
    if (!keys.length) return url;
    return url + '?' + Object.keys(data).map(function(key) {
      var param = key;
      if (data[key] !== null) {
        param += '=' + encodeURIComponent(data[key]);
      }
      return param;
    }).join('&');
  }

  function getBoldManagementUrl(cb) {
    getBoldCredentials(function(err, creds) {
      if (err) return cb(err);
      /* eslint-disable camelcase */
      cb(
        null,
        makeGetUrl('https://recurringcheckout.com/s/' + shop + '/front_end/recurring_orders', {
          bold_token: creds.bold_token,
          bold_signature: creds.bold_signature
        })
      );
      /* eslint-enable camelcase */
    });
  }

  function cancelSubscription(id, cb) {
    getBoldCredentials(function(err, credentials) {
      if (err) return cb(err);
      /*eslint-disable camelcase */
      var data = {
        id: id,
        cancel_reason: '',
        bold_token: credentials.bold_token,
        bold_signature: credentials.bold_signature,
      };
      /*eslint-enable camelcase */

      $.ajax({
        url: apiUrl('delete_order'),
        type: 'post',
        data: data,
        cache: false,
        success: function() {
          cb();
        },
        error: ajaxError(cb, null, [302])
      });
    });
  }

  function dateToStr(date) {
    if (date.toLocaleDateString) {
      return date.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
    }

    var months = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec'
    ];
    return months[date.getMonth()] + ' ' + date.getDate() + ', ' + date.getFullYear();
  }

  function setCustomerField(name, value, cb) {
    if (!isLoggedIn()) return cb(new Error('Customer not logged in'));

    var time = (new Date()).getTime();
    var id = BOLD.customer.id;
    var email = BOLD.customer.email;
    var hash = sha256(String(time) + email + String(id));
    $.ajax({
      url: backend + '/shopify/set_customer_meta',
      type: 'post',
      contentType: 'application/json; charset=utf-8',
      processData: false,
      data: JSON.stringify({
        id: id,
        time: time,
        hash: hash,
        name: name,
        value: value,
      }),
      success: function(response) {
        cb(null, response);
      },
      error: ajaxError(cb, 'storing customer info')
    });
  }

  return {
    getBoldManagementUrl: getBoldManagementUrl,
    decodeQuery: decodeQuery,
    getSubscriptions: getSubscriptions,
    getSubscriptionInfo: getSubscriptionInfo,
    getAllSubscriptionInfo: getAllSubscriptionInfo,
    variantFromSku: variantFromSku,
    clearCart: clearCart,
    addSubscriptionToCart: addSubscriptionToCart,
    swapProduct: swapProduct,
    skipShipSubscriptionOrder: skipShipSubscriptionOrder,
    setNextOrderDate: setNextOrderDate,
    async: async,
    mapSerial: mapSerial,
    makeGetUrl: makeGetUrl,
    dateAsIso: dateAsIso,
    cancelSubscription: cancelSubscription,
    isLoggedIn: isLoggedIn,
    loginAndRedirect: loginAndRedirect,
    skuInfo: skuInfo,
    fetchSupplementFacts: fetchSupplementFacts,
    dateToStr: dateToStr,
    setCustomerField: setCustomerField
  };

  var sha256func;

  function sha256(message) {
    /* eslint-disable */
    if (!sha256func) {
      var module = { exports: {} };

      /**
       * [js-sha256]{@link https://github.com/emn178/js-sha256}
       *
       * @version 0.6.0
       * @author Chen, Yi-Cyuan [emn178@gmail.com]
       * @copyright Chen, Yi-Cyuan 2014-2017
       * @license MIT
       */
      !function(){"use strict";function t(t,i){i?(p[0]=p[16]=p[1]=p[2]=p[3]=p[4]=p[5]=p[6]=p[7]=p[8]=p[9]=p[10]=p[11]=p[12]=p[13]=p[14]=p[15]=0,this.blocks=p):this.blocks=[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],t?(this.h0=3238371032,this.h1=914150663,this.h2=812702999,this.h3=4144912697,this.h4=4290775857,this.h5=1750603025,this.h6=1694076839,this.h7=3204075428):(this.h0=1779033703,this.h1=3144134277,this.h2=1013904242,this.h3=2773480762,this.h4=1359893119,this.h5=2600822924,this.h6=528734635,this.h7=1541459225),this.block=this.start=this.bytes=0,this.finalized=this.hashed=!1,this.first=!0,this.is224=t}function i(i,r,e){var n="string"!=typeof i;if(n){if(null===i||void 0===i)throw h;i.constructor===s.ArrayBuffer&&(i=new Uint8Array(i))}var o=i.length;if(n){if("number"!=typeof o||!Array.isArray(i)&&(!a||!ArrayBuffer.isView(i)))throw h}else{for(var f,u=[],o=i.length,c=0,y=0;o>y;++y)f=i.charCodeAt(y),128>f?u[c++]=f:2048>f?(u[c++]=192|f>>6,u[c++]=128|63&f):55296>f||f>=57344?(u[c++]=224|f>>12,u[c++]=128|f>>6&63,u[c++]=128|63&f):(f=65536+((1023&f)<<10|1023&i.charCodeAt(++y)),u[c++]=240|f>>18,u[c++]=128|f>>12&63,u[c++]=128|f>>6&63,u[c++]=128|63&f);i=u}i.length>64&&(i=new t(r,!0).update(i).array());for(var p=[],l=[],y=0;64>y;++y){var d=i[y]||0;p[y]=92^d,l[y]=54^d}t.call(this,r,e),this.update(l),this.oKeyPad=p,this.inner=!0,this.sharedMemory=e}var h="input is invalid type",s="object"==typeof window?window:{},r=!s.JS_SHA256_NO_NODE_JS&&"object"==typeof process&&process.versions&&process.versions.node;r&&(s=global);var e=!s.JS_SHA256_NO_COMMON_JS&&"object"==typeof module&&module.exports,n="function"==typeof define&&define.amd,a="undefined"!=typeof ArrayBuffer,o="0123456789abcdef".split(""),f=[-2147483648,8388608,32768,128],u=[24,16,8,0],c=[1116352408,1899447441,3049323471,3921009573,961987163,1508970993,2453635748,2870763221,3624381080,310598401,607225278,1426881987,1925078388,2162078206,2614888103,3248222580,3835390401,4022224774,264347078,604807628,770255983,1249150122,1555081692,1996064986,2554220882,2821834349,2952996808,3210313671,3336571891,3584528711,113926993,338241895,666307205,773529912,1294757372,1396182291,1695183700,1986661051,2177026350,2456956037,2730485921,2820302411,3259730800,3345764771,3516065817,3600352804,4094571909,275423344,430227734,506948616,659060556,883997877,958139571,1322822218,1537002063,1747873779,1955562222,2024104815,2227730452,2361852424,2428436474,2756734187,3204031479,3329325298],y=["hex","array","digest","arrayBuffer"],p=[];(s.JS_SHA256_NO_NODE_JS||!Array.isArray)&&(Array.isArray=function(t){return"[object Array]"===Object.prototype.toString.call(t)});var l=function(i,h){return function(s){return new t(h,!0).update(s)[i]()}},d=function(i){var h=l("hex",i);r&&(h=v(h,i)),h.create=function(){return new t(i)},h.update=function(t){return h.create().update(t)};for(var s=0;s<y.length;++s){var e=y[s];h[e]=l(e,i)}return h},v=function(t,i){var s=require("crypto"),r=require("buffer").Buffer,e=i?"sha224":"sha256",n=function(i){if("string"==typeof i)return s.createHash(e).update(i,"utf8").digest("hex");if(null===i||void 0===i)throw h;return i.constructor===ArrayBuffer&&(i=new Uint8Array(i)),Array.isArray(i)||ArrayBuffer.isView(i)||i.constructor===r?s.createHash(e).update(new r(i)).digest("hex"):t(i)};return n},A=function(t,h){return function(s,r){return new i(s,h,!0).update(r)[t]()}},w=function(t){var h=A("hex",t);h.create=function(h){return new i(h,t)},h.update=function(t,i){return h.create(t).update(i)};for(var s=0;s<y.length;++s){var r=y[s];h[r]=A(r,t)}return h};t.prototype.update=function(t){if(!this.finalized){var i="string"!=typeof t;if(i){if(null===t||void 0===t)throw h;t.constructor===s.ArrayBuffer&&(t=new Uint8Array(t))}var r=t.length;if(!(!i||"number"==typeof r&&(Array.isArray(t)||a&&ArrayBuffer.isView(t))))throw h;for(var e,n,o=0,f=this.blocks;r>o;){if(this.hashed&&(this.hashed=!1,f[0]=this.block,f[16]=f[1]=f[2]=f[3]=f[4]=f[5]=f[6]=f[7]=f[8]=f[9]=f[10]=f[11]=f[12]=f[13]=f[14]=f[15]=0),i)for(n=this.start;r>o&&64>n;++o)f[n>>2]|=t[o]<<u[3&n++];else for(n=this.start;r>o&&64>n;++o)e=t.charCodeAt(o),128>e?f[n>>2]|=e<<u[3&n++]:2048>e?(f[n>>2]|=(192|e>>6)<<u[3&n++],f[n>>2]|=(128|63&e)<<u[3&n++]):55296>e||e>=57344?(f[n>>2]|=(224|e>>12)<<u[3&n++],f[n>>2]|=(128|e>>6&63)<<u[3&n++],f[n>>2]|=(128|63&e)<<u[3&n++]):(e=65536+((1023&e)<<10|1023&t.charCodeAt(++o)),f[n>>2]|=(240|e>>18)<<u[3&n++],f[n>>2]|=(128|e>>12&63)<<u[3&n++],f[n>>2]|=(128|e>>6&63)<<u[3&n++],f[n>>2]|=(128|63&e)<<u[3&n++]);this.lastByteIndex=n,this.bytes+=n-this.start,n>=64?(this.block=f[16],this.start=n-64,this.hash(),this.hashed=!0):this.start=n}return this}},t.prototype.finalize=function(){if(!this.finalized){this.finalized=!0;var t=this.blocks,i=this.lastByteIndex;t[16]=this.block,t[i>>2]|=f[3&i],this.block=t[16],i>=56&&(this.hashed||this.hash(),t[0]=this.block,t[16]=t[1]=t[2]=t[3]=t[4]=t[5]=t[6]=t[7]=t[8]=t[9]=t[10]=t[11]=t[12]=t[13]=t[14]=t[15]=0),t[15]=this.bytes<<3,this.hash()}},t.prototype.hash=function(){var t,i,h,s,r,e,n,a,o,f,u,y=this.h0,p=this.h1,l=this.h2,d=this.h3,v=this.h4,A=this.h5,w=this.h6,b=this.h7,g=this.blocks;for(t=16;64>t;++t)r=g[t-15],i=(r>>>7|r<<25)^(r>>>18|r<<14)^r>>>3,r=g[t-2],h=(r>>>17|r<<15)^(r>>>19|r<<13)^r>>>10,g[t]=g[t-16]+i+g[t-7]+h<<0;for(u=p&l,t=0;64>t;t+=4)this.first?(this.is224?(a=300032,r=g[0]-1413257819,b=r-150054599<<0,d=r+24177077<<0):(a=704751109,r=g[0]-210244248,b=r-1521486534<<0,d=r+143694565<<0),this.first=!1):(i=(y>>>2|y<<30)^(y>>>13|y<<19)^(y>>>22|y<<10),h=(v>>>6|v<<26)^(v>>>11|v<<21)^(v>>>25|v<<7),a=y&p,s=a^y&l^u,n=v&A^~v&w,r=b+h+n+c[t]+g[t],e=i+s,b=d+r<<0,d=r+e<<0),i=(d>>>2|d<<30)^(d>>>13|d<<19)^(d>>>22|d<<10),h=(b>>>6|b<<26)^(b>>>11|b<<21)^(b>>>25|b<<7),o=d&y,s=o^d&p^a,n=b&v^~b&A,r=w+h+n+c[t+1]+g[t+1],e=i+s,w=l+r<<0,l=r+e<<0,i=(l>>>2|l<<30)^(l>>>13|l<<19)^(l>>>22|l<<10),h=(w>>>6|w<<26)^(w>>>11|w<<21)^(w>>>25|w<<7),f=l&d,s=f^l&y^o,n=w&b^~w&v,r=A+h+n+c[t+2]+g[t+2],e=i+s,A=p+r<<0,p=r+e<<0,i=(p>>>2|p<<30)^(p>>>13|p<<19)^(p>>>22|p<<10),h=(A>>>6|A<<26)^(A>>>11|A<<21)^(A>>>25|A<<7),u=p&l,s=u^p&d^f,n=A&w^~A&b,r=v+h+n+c[t+3]+g[t+3],e=i+s,v=y+r<<0,y=r+e<<0;this.h0=this.h0+y<<0,this.h1=this.h1+p<<0,this.h2=this.h2+l<<0,this.h3=this.h3+d<<0,this.h4=this.h4+v<<0,this.h5=this.h5+A<<0,this.h6=this.h6+w<<0,this.h7=this.h7+b<<0},t.prototype.hex=function(){this.finalize();var t=this.h0,i=this.h1,h=this.h2,s=this.h3,r=this.h4,e=this.h5,n=this.h6,a=this.h7,f=o[t>>28&15]+o[t>>24&15]+o[t>>20&15]+o[t>>16&15]+o[t>>12&15]+o[t>>8&15]+o[t>>4&15]+o[15&t]+o[i>>28&15]+o[i>>24&15]+o[i>>20&15]+o[i>>16&15]+o[i>>12&15]+o[i>>8&15]+o[i>>4&15]+o[15&i]+o[h>>28&15]+o[h>>24&15]+o[h>>20&15]+o[h>>16&15]+o[h>>12&15]+o[h>>8&15]+o[h>>4&15]+o[15&h]+o[s>>28&15]+o[s>>24&15]+o[s>>20&15]+o[s>>16&15]+o[s>>12&15]+o[s>>8&15]+o[s>>4&15]+o[15&s]+o[r>>28&15]+o[r>>24&15]+o[r>>20&15]+o[r>>16&15]+o[r>>12&15]+o[r>>8&15]+o[r>>4&15]+o[15&r]+o[e>>28&15]+o[e>>24&15]+o[e>>20&15]+o[e>>16&15]+o[e>>12&15]+o[e>>8&15]+o[e>>4&15]+o[15&e]+o[n>>28&15]+o[n>>24&15]+o[n>>20&15]+o[n>>16&15]+o[n>>12&15]+o[n>>8&15]+o[n>>4&15]+o[15&n];return this.is224||(f+=o[a>>28&15]+o[a>>24&15]+o[a>>20&15]+o[a>>16&15]+o[a>>12&15]+o[a>>8&15]+o[a>>4&15]+o[15&a]),f},t.prototype.toString=t.prototype.hex,t.prototype.digest=function(){this.finalize();var t=this.h0,i=this.h1,h=this.h2,s=this.h3,r=this.h4,e=this.h5,n=this.h6,a=this.h7,o=[t>>24&255,t>>16&255,t>>8&255,255&t,i>>24&255,i>>16&255,i>>8&255,255&i,h>>24&255,h>>16&255,h>>8&255,255&h,s>>24&255,s>>16&255,s>>8&255,255&s,r>>24&255,r>>16&255,r>>8&255,255&r,e>>24&255,e>>16&255,e>>8&255,255&e,n>>24&255,n>>16&255,n>>8&255,255&n];return this.is224||o.push(a>>24&255,a>>16&255,a>>8&255,255&a),o},t.prototype.array=t.prototype.digest,t.prototype.arrayBuffer=function(){this.finalize();var t=new ArrayBuffer(this.is224?28:32),i=new DataView(t);return i.setUint32(0,this.h0),i.setUint32(4,this.h1),i.setUint32(8,this.h2),i.setUint32(12,this.h3),i.setUint32(16,this.h4),i.setUint32(20,this.h5),i.setUint32(24,this.h6),this.is224||i.setUint32(28,this.h7),t},i.prototype=new t,i.prototype.finalize=function(){if(t.prototype.finalize.call(this),this.inner){this.inner=!1;var i=this.array();t.call(this,this.is224,this.sharedMemory),this.update(this.oKeyPad),this.update(i),t.prototype.finalize.call(this)}};var b=d();b.sha256=b,b.sha224=d(!0),b.sha256.hmac=w(),b.sha224.hmac=w(!0),e?module.exports=b:(s.sha256=b.sha256,s.sha224=b.sha224,n&&define(function(){return b}))}(); //eslint-disable-line

      sha256func = module.exports.sha256;
    }
    return sha256func(message);
    /* eslint-enable */
  }
})();
